'use strict';



//////////////////
// WEBPACK FOOTER
// ./~/tartan-processing/src/filter/index.js
// module id = 103
// module chunks = 0